/**
 * Project : workspace
 * File    : ImagePicker.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package native.files

/**
 * Represents the image picker class.
 */

class ImagePicker {
    companion object {
        private var instance: ImagePicker? = null
        /**
 * Executes the shared operation.
 *
 * @receiver TODO
 * @return The resulting image picker.
 */
        fun shared(): ImagePicker {
            return if (instance != null) {
                instance as ImagePicker
            } else {
                instance = ImagePicker()
                instance as ImagePicker
            }
        }
    }

    init {
        instance = this
    }

    var pickImage: () -> Unit = {}
    var requestPermission: () -> Unit = {}
    var onPermissionChange: (Boolean) -> Unit = {}
    var onImagePicked: (String) -> Unit = {}

}